export default {
  updateActiveStatus (state, status) {
    state.active = status
  },

  updateMessage (state, message) {
    state.message = message
  }
}
